<template>
  <v-container fluid>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-if="error">
            <v-card class="mb-4">
                <v-card-text>
                <p class="mb-0 red--text"><b>{{error.title}}:</b> {{error.message}}</p>
                </v-card-text>
            </v-card>
        </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-if="isValid">
        <div class="headline mb-4 text-center">Email Confirmed</div>
        <v-card>
          <v-card-text>
            <p>Thank you for confirming your email. Click the button below to login and start using the tools.</p>
            <v-btn block type="submit" to="/login" color="primary">Log in</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isValid: false
  }),
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    var hash = this.$route.params.hash
    this.$store.dispatch('confirmEmail', { hash: hash }).then(() => {
      this.isValid = true
    }).catch((error) => {
      console.log(error)
      this.isValid = false
    })
  }
}
</script>
